import { Component, inject } from '@angular/core';
import {
  BaseCommonClientRequest,
  ClientRequestIdentityHelper,
  CommonClientRequestDocumentUpload,
  CommonClientRequestFactoryService
} from '@aiwyn/common/client-requests';
import { Store } from '@ngxs/store';
import { ClientRequestsState } from '../../state';
import { map, shareReplay } from 'rxjs/operators';
import { ClientRequestDocumentUploadModel, ClientRequestModel } from '@aiwyn/api';
import { DATA_SELECTOR_INJECTION_TOKEN, ignoreNullish } from '@aiwyn/shared';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-client-request-details',
  templateUrl: './client-request-details.component.html',
  styleUrls: ['./client-request-details.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'client-request-details',
    },
  ],
  standalone: false,
})
export class ClientRequestDetailsComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);
  
  instance$ = this.store.select(ClientRequestsState.getSlices.selectedRequestId).pipe(
    ignoreNullish(),
    map(id => ClientRequestIdentityHelper.getRequestIdentity({ id } as ClientRequestModel)),
    map(identity => this.factoryService.getClientRequest(identity)),
    shareReplay(1),
  ) as Observable<BaseCommonClientRequest<ClientRequestDocumentUploadModel, CommonClientRequestDocumentUpload>>;

  constructor(
    private readonly factoryService: CommonClientRequestFactoryService,
    private readonly store: Store,
  ) {}
}
